import React from 'react';
import MarkdownComponent from 'containers/user/learn/components/markdown/markdown';

interface ParagraphProps {
  title?: string;
  text?: string;
  id: string | number;
}

const Paragraph = ({
  title = '',
  text = '',
  id,
}: ParagraphProps): React.JSX.Element => (
  <div className="mobile:mb-6 xs:mb-8">
    {title && (
      <h2
        id={`block_${id}`}
        className="text-2xl font-semibold pb-2 text-neutral-950"
      >
        {title}
      </h2>
    )}
    <MarkdownComponent text={text} />
  </div>
);

export default Paragraph;
